import React from 'react';

interface MobileTitleBarProps {
    title: string;
    projectName?: string;
    projectCode?: string;
    delayDays?: number;
    delayStatusText?: string;
    rightAction?: React.ReactNode;
}

export const MobileTitleBar: React.FC<MobileTitleBarProps> = ({
    title,
    projectName,
    projectCode,
    delayDays,
    delayStatusText,
    rightAction
}) => {
    // Si viene información de proyecto, mostramos la variante extendida de 2 líneas
    const hasProjectInfo = Boolean(projectName || projectCode || delayDays !== undefined || delayStatusText);

    if (hasProjectInfo) {
        const fullProjectTitle = projectCode && projectName && !projectName.startsWith(projectCode)
            ? `${projectCode} - ${projectName}`
            : projectName || projectCode || '';
        const badgeLabel = delayStatusText || (delayDays && delayDays > 0 ? `Atrasado · ${delayDays}d` : null);

        const isDelayed = Boolean((delayDays && delayDays > 0) || (delayStatusText && (delayStatusText.includes('Atrasado') || delayStatusText.includes('desvío'))));
        const isWarning = Boolean(delayStatusText && delayStatusText.includes('Riesgo'));
        const badgeBg = isDelayed ? 'var(--kl-danger-bg, #FEE2E2)' : isWarning ? 'var(--kl-warning-bg, #FEF3C7)' : 'var(--kl-success-bg, #ECFDF5)';
        const badgeColor = isDelayed ? 'var(--kl-danger-text, #B91C1C)' : isWarning ? 'var(--kl-warning-text, #B45309)' : 'var(--kl-success-text, #047857)';

        return (
            <div
                style={{
                    background: 'var(--kl-primary, #2563EB)',
                    color: '#ffffff',
                    padding: '6px 12px 8px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    gap: '2px',
                    boxSizing: 'border-box'
                }}
            >
                {/* 1. Línea superior: Obra (alineada siempre a la izquierda) */}
                {fullProjectTitle && (
                    <span
                        style={{
                            fontSize: '12px',
                            fontWeight: 500,
                            opacity: 0.92,
                            textAlign: 'left',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {fullProjectTitle}
                    </span>
                )}

                {/* 2. Línea inferior: Título a la izquierda + Badge de atraso a la derecha */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    <span
                        style={{
                            fontSize: '16px',
                            fontWeight: 700,
                            textAlign: 'left',
                            letterSpacing: '-0.01em'
                        }}
                    >
                        {title}
                    </span>

                    {badgeLabel && (
                        <span
                            style={{
                                background: badgeBg,
                                color: badgeColor,
                                fontSize: '11px',
                                fontWeight: 600,
                                height: '22px',
                                padding: '0 8px',
                                borderRadius: '11px',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            {badgeLabel}
                        </span>
                    )}

                    {rightAction && !badgeLabel && (
                        <div>{rightAction}</div>
                    )}
                </div>
            </div>
        );
    }

    // Variante 1: Barra azul simple de 44px (Calidad, Subcontratos)
    return (
        <div
            style={{
                background: 'var(--kl-primary, #2563EB)',
                color: '#ffffff',
                padding: '0 12px',
                height: 'var(--kl-h-titlebar, 44px)',
                display: 'flex',
                alignItems: 'center',
                boxSizing: 'border-box',
                fontSize: '16px',
                fontWeight: 700,
                textAlign: 'left',
                justifyContent: 'space-between'
            }}
        >
            <span style={{ textAlign: 'left', flex: 1 }}>{title}</span>
            {rightAction && <div>{rightAction}</div>}
        </div>
    );
};
